import { Card } from '@mui/material'
import { styled } from '@mui/material/styles'

const HomeCard = styled(Card)(() => ({
  '& .MuiCardHeader-root': {
    fontFamily: 'Prompt'
  },
  '& .MuiCardActions-root': {
    padding: '0px 14px 14px 14px',
    justifyContent: 'flex-end'
  },
  '& .MuiLink-root': {
    textDecoration: 'none'
  }
}))

export default HomeCard
